module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/genai-7cea32681cb605ffe87623b35dcd90e7.svg";